import React, { useState } from "react";
import {
    ComposableMap,
    Geographies,
    Geography,
    ZoomableGroup,
    Annotation,
    Markers,
    Marker
} from "react-simple-maps";
import { geoPath } from "d3-geo";
import { geoTimes } from "d3-geo-projection";

const geoUrl =
    "./features.json";
var loca1 = [0, 0]
var clicked = false
var zoomedtext = "Zoom in"



const MapChart = (props) => {
    const [zoom, setZoom] = useState(1);
    const [center, setCenter] = useState([0, 0]);
    const [dummycenter, setDummyCenter] = useState([0, 0]);

    const markers = [
        {
            markerOffset: 0,
            name: "Zoom in",
            coordinates: [-558.3816, 254.6037]
        },


    ];

    const generateColor = () => {
        let randomColorString = "#";
        const arrayOfColorFunctions = "0123456789abcdef";
        for (let x = 0; x < 6; x++) {
            let index = Math.floor(Math.random() * 16);
            let value = arrayOfColorFunctions[index];

            randomColorString += value;
        }
        // console.log(randomColorString)
        return randomColorString;
    };


    const handleGeographyClick = () => event => {

        if (clicked) {
            setCenter([0, 0])
            clicked = false
            setZoom(1);
            zoomedtext = "Zoom in"
        }
        else {
            clicked = true
            setCenter(loca1)
            setZoom(15);
            zoomedtext = "Zoom out"
        }

        //  console.log("handleGeographyClick")

        // console.log(loca1)
        // setCenter(centroid);


        // setCenter([0, 0])

        // setCenter(loca1)
        // setZoom(6);
    };

    const projection = () => {
        return geoTimes()
            .translate([800 / 2, 450 / 2])
            .scale(160);
    };


    const doNothing = (geography, projection, path) => (event) => {

    };

    const gotoMap = () => {
        //  console.log("Clicked")
        setCenter(loca1);

    }

    const handleLoad = (selectedcountry, requiredcountry, geography, projection, path) => {
        //console.log(selectedcountry)
        //console.log(requiredcountry)


        //const centroid = projection.invert(path.centroid(geography));

        if (selectedcountry == requiredcountry) {
            // console.log("Loaded geographies")
            const centroid = projection.invert(path.centroid(geography));
            // console.log(centroid)
            loca1 = centroid
            //console.log(requiredcountry)
        }


        // if (selectedcountry == requiredcountry) {
        //     console.log("Loaded geographies")
        //     console.log(requiredcountry)



        //     console.log("Called")
        //     const centroid = projection.invert(path.centroid(geography));
        //     setCenter(centroid);
        //     setZoom(4);
        // }
        // if (selectedcountry == requiredcountry) {
        //     console.log("Loaded geographies")
        //     console.log(requiredcountry)
        //     const centroid = projection.invert(path.centroid(geography));
        //     setCenter(centroid);
        //     setZoom(4);

        // }

    }


    return (

        <ComposableMap width={665} height={420}

            projectionConfig={{
                rotate: [props.rotation, props.xaxis, 0],
                scale: props.scale
            }}
        >

            <ZoomableGroup center={center} zoom={zoom}>
                <Geographies geography="./features.json">
                    {({ geographies, projection, path }) =>
                        geographies.map((geography) => {
                            const isClicked = props.country === geography.properties.name;

                            return (

                                <Geography
                                    key={geography.rsmKey}
                                    geography={geography}
                                    fill={isClicked ? "green" : "grey"}

                                    outline="none"
                                    geographypathsloaded={handleLoad(geography.properties.name, props.country, geography, projection, path)}

                                />


                            );
                        })

                    }
                </Geographies>


            </ZoomableGroup>
            {/* 



            {
                markers.map(({ name, coordinates, markerOffset }) => (
                    <Marker key={name} coordinates={coordinates}  >

                        <g onClick={handleGeographyClick()}
                            fill="none"
                            stroke="#FF5533"
                            strokeWidth="4"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            transform="translate(-12, -24)"

                        >

                            <circle cx="12" cy="10" r="3" />
                            <path d="M12 21.7C17.3 17 20 13 20 10a8 8 0 1 0-16 0c0 3 2.7 6.9 8 11.7z" />
                        </g>

                        <text
                            textAnchor="middle"
                            y={markerOffset}
                            style={{ fontFamily: "system-ui", fill: "#5D5A6D" }}

                        >
                            {zoomedtext}
                        </text>
                    </Marker>
                ))
            } */}


            <Annotation
                subject={[2.3522, 48.8566]}
                dx={-200}
                dy={300}
                connectorProps={{
                    stroke: "#FF5533",
                    strokeWidth: 0,
                    strokeLinecap: "round"
                }}
            >

                <g onClick={handleGeographyClick()}
                    fill="none"
                    stroke="#FF5533"
                    strokeWidth="4"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    transform="translate(-12, -24)"

                >

                    <circle cx="12" cy="10" r="3" />
                    <path d="M12 21.7C17.3 17 20 13 20 10a8 8 0 1 0-16 0c0 3 2.7 6.9 8 11.7z" />
                </g>
                <text
                    textAnchor="middle"
                    y={20}
                    style={{ fontFamily: "system-ui", fill: "#5D5A6D" }}

                >
                    {zoomedtext}
                </text>


            </Annotation>


        </ComposableMap >


    );
};

export default MapChart;


